import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import Dialog from '@/components/Dialog';
import Button from '@/components/Button';
import type { LearnPage } from '@edwin-group/cj-graphql/generated/graphql';

function DialogConfirmation({
  open,
  setOpen,
  onConfirm,
  onCancel,
  learnPage,
  customTitle,
  customDescription,
  confirmButtonText,
  cancelButtonText,
}: {
  open?: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
  onCancel: () => void;
  learnPage?: LearnPage | null;
  customTitle?: string;
  customDescription?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}) {
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={customTitle || learnPage?.modalLeavePage?.title || 'Are you sure you want to leave?'}
      body={
        <>
          <AnimatedFadeInComponent>
            <p className="text-justify text-sh-sm">
              {customDescription ||
                learnPage?.modalLeavePage?.description ||
                'You have unsaved changes that will be lost if you leave this page. Are you sure you want to continue?'}
            </p>
            <div className="mt-6 flex items-start justify-end gap-4">
              <Button
                theme="outline"
                onClick={() => {
                  onConfirm();
                }}>
                {confirmButtonText || learnPage?.modalLeavePage?.confirmButton || 'Leave Page'}
              </Button>
              <Button
                theme="solid"
                onClick={() => {
                  onCancel();
                  setOpen(false);
                }}>
                {cancelButtonText || learnPage?.modalLeavePage?.cancelButton || 'Stay on Page'}
              </Button>
            </div>
          </AnimatedFadeInComponent>
        </>
      }
    />
  );
}

export default DialogConfirmation;
